import React from 'react';
import { observer, inject } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

import Header from '../components/core/Header/Header';

const styles = (theme) => ({
  container: {
    display: 'flex',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '100px',
  },
  loader: {
    width: '100px',
    height: '100px',
  },
});

class Landing extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
    };
  }

  componentDidMount() {
    this.props.userStore.logout();

    this.setState((state) => ({ ...state, isLoading: false }));
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Header hideNav />
        <div className={classes.container}>
          <CircularProgress />
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(inject('userStore', 'languageStore')(observer(Landing)));
